import React from "react";
import FeatureGridItem2 from "../components/FeatureGridItem2";
import { features4 as featuresContent } from "../content";

export default function FeatureGridSection3({ features = featuresContent } = {}) {
  return (
    <section className="relative isolate py-20 px-6 sm:px-12 bg-white" id="pricing" style={{ backgroundColor: "#ffffff" }}>

      {/* Glow Blur Accent */}
      <div className="h-96 absolute top-10 inset-x-0 -z-10 px-36 overflow-hidden filter blur-3xl pointer-events-none opacity-20 aria-hidden">
        <div className="mx-auto aspect-[1155/678] w-[60rem] bg-gradient-to-tr from-[#7c3aed] to-[#38bdf8] rounded-full" />
      </div>

      {/* Header */}
      <div className="mx-auto text-center max-w-3xl">
        <div className="inline-flex items-center gap-2 font-mono text-xs font-bold uppercase tracking-wider mb-3" style={{ color: "#7c3aed" }}>
          Transparent Pricing
        </div>
        <h2 className="text-4xl sm:text-5xl font-extrabold tracking-tight leading-tight text-balance" style={{ color: "#0f172a" }}>
          Simple Pricing, Powerful Security
        </h2>
        <p className="mt-4 mx-auto text-base sm:text-lg font-medium leading-relaxed max-w-2xl" style={{ color: "#334155" }}>
          Get started for free with threat modeling for your core application, or scale up with our Enterprise subscription designed to secure your entire organization.
        </p>
      </div>

      {/* Cards Grid */}
      <div className="w-full grid mt-14 mb-8 gap-8 mx-auto max-w-7xl grid-cols-1 lg:grid-cols-3">
        {features.map((d) => (
          <FeatureGridItem2 key={d.variant} d={d} />
        ))}
      </div>
    </section>
  );
}



